import { createAction, type CommonThunkAction } from '@wix/communities-blog-client-common';
import { parseInstance, type ParsedInstance } from './parse-instance';

export const setInstanceValues = createAction(
  'instanceValues/SET',
  (payload: ParsedInstance) => payload,
);

export const initializeInstanceValues =
  (instance: string | undefined): CommonThunkAction =>
  (dispatch) => {
    const parsedInstance = parseInstance(instance);

    dispatch(setInstanceValues(parsedInstance));
  };
